// extracted by mini-css-extract-plugin
export var icon = "_wl-0";